import { render, staticRenderFns } from "./CommonConfigEdit.vue?vue&type=template&id=1ede8174&scoped=true&"
import script from "./CommonConfigEdit.vue?vue&type=script&lang=js&"
export * from "./CommonConfigEdit.vue?vue&type=script&lang=js&"
import style0 from "./CommonConfigEdit.vue?vue&type=style&index=0&id=1ede8174&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ede8174",
  null
  
)

export default component.exports